import React from "react";
import { Col, Row } from "reactstrap";
import { currencyFormater } from "../../utils/lib";

const MYOBInvoicesTotal = ({
  total = 0,
  totalExGst = 0,
  gstAmount = 0,
}) => {
  return (
    <div className="full-width">
      <Row>
        <Col xs={2} md={4} lg={8}></Col>
        <Col xs={5} md={4} lg={2}>
          Sub Total
        </Col>
        <Col xs={5} md={4} lg={2} className="text-right">
          {currencyFormater(totalExGst || 0)}
        </Col>
      </Row>
      <Row>
        <Col xs={2} md={4} lg={8}></Col>
        <Col xs={5} md={4} lg={2}>
          GST
        </Col>
        <Col xs={5} md={4} lg={2} className="text-right">
          {currencyFormater(gstAmount || 0)}
        </Col>
      </Row>
      <Row>
        <Col xs={2} md={4} lg={8}></Col>
        <Col xs={5} md={4} lg={2}>
          Total
        </Col>
        <Col xs={5} md={4} lg={2} className="text-right">
          {currencyFormater(
            total
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MYOBInvoicesTotal;
